import { Component, HostBinding, Input, ViewChild } from '@angular/core';
import { DateRangeHolder } from '../../../shared/domain/date-range-holder.model';
import { WidgetDailyMetricsChartComponent } from '../../shared/components/widgets/widget-daily-metrics-chart.component';
import { WidgetAlertsComponent } from '../../shared/components/widgets/alerts/widget-alerts.component';
import { WidgetStatusChangeComponent } from '../../shared/components/widgets/alerts/widget-status-change.component';
import { ReportResponse } from '../../shared/domain/report/report-response.model';

@Component({
  selector: 'cm-kn-dashboard-main-widgets',
  template: `
    <div class="row">
      <cm-widget-daily-metrics-chart [menuVisible]="false" #daily
                                     class="col-12 col-xl-8 mb-4 d-none d-md-block"></cm-widget-daily-metrics-chart>
      <div class="col-12 col-xl-4 mb-4">
        <div class="cm-card">
          <mat-tab-group mat-stretch-tabs (selectedTabChange)="selectedWidgetTabChange($event)">
            <mat-tab label="Status change">
              <cm-widget-status-change></cm-widget-status-change>
            </mat-tab>
            <mat-tab label="Alerts">
              <cm-widget-alerts [menuVisible]="false"></cm-widget-alerts>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
  `,
  host: { 'class': 'cm-kn-dashboard-main-widgets' }
})
export class KitchenDashboardMainWidgetsComponent {
  @ViewChild(WidgetDailyMetricsChartComponent, { static: true }) daily: WidgetDailyMetricsChartComponent;
  @ViewChild(WidgetAlertsComponent, { static: true }) widgetAlerts: WidgetAlertsComponent;
  @ViewChild(WidgetStatusChangeComponent, { static: true }) widgetStatusChange: WidgetStatusChangeComponent;

  @Input()
  loading: boolean;

  @Input()
  set data(data: ReportResponse) {
    this._data = data;
  }

  @Input()
  set publisherIds(publisherIds: string[]) {
    this._publisherIds = publisherIds;
  }

  @Input()
  set dateRange(dateRange: DateRangeHolder) {
    if (this._dateRange) {
      // dont pass in first request
      this.daily.setDateRange(dateRange);
    }
    this._dateRange = dateRange;
  }

  _publisherIds: string[];
  _dateRange: DateRangeHolder;
  _data: ReportResponse;


  selectedWidgetTabChange(event) {
    if (event.index === 0) {
      this.widgetAlerts.refreshData();
    } else {
      this.widgetStatusChange.refreshData();
    }
  }
}
